import OpenConsoleApi from '@/api/OpenConsoleApi';
import { Config } from '@/api/http';
import store from '@/store';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import { OemModule } from './oem.module';

interface ProviderModel {
  id: number,
  name: string,
  capacityAlarm: number,
  capacityAlarmType: string,
  isOpenSmsNotify: boolean,
  isOpenResources: boolean,
  isOpenHelpcenter: boolean,
  isInfoCompleted: boolean,
  isAloneDomainChecked: boolean,
  recordNumber: string,
  subDomain: string
}
interface UserModel {
  id: number,
  email: string,
  emailExamined: boolean,
  loginLogNotify: boolean,
  mobilePhone: string,
  mobilePhoneExamined: boolean,
  name: string,
  nickname: string,
  phone: string,
  photo: {
    contentUrl: string
  },
  photoContentUrl: string,
  role: {
    name: string,
    nameKey: string
  }
}
interface EngineerModel {
  id: number,
  concurrentChatNumber: number,
  defaultServiceDeskId: number, // 首选客服组ID
  defaultServiceDeskName: string, // 首选客服组名称
  isCreator: boolean, // 是否是创始人
  maxConcurrentChatNumber: number, // 最大会话数
  minConcurrentChatNumber: number, // 最小会话数
  nickname: string, // 昵称
  providerId: number, // 所属服务商ID
  role: {
    id: number,
    name: string,
    nameKey: string,
    type: string
  },
  roleId: number, // 角色ID
  roleName: string, // 角色名
  roleNameKey: string, // 角色类
  sipAccount: string, // ?
  userEmail: string, // 邮箱
  userId: number, 
  userName: string
}
interface pwdModel {
  forceUpdatePasswordTipDay: number,
  prevUpdatePasswordDate: string,
  updatePasswordTipDay: number
}
interface ProviderState {
  provider: ProviderModel,
  user: UserModel,
  engineer: EngineerModel,
  serviceDeskIds: Array<number>,
  passwordValidity: pwdModel,
  permissions: Array<string>,
  mainPic: string, // 主图
  eweiHelpcenterApiUrl?: string
}

@Module({ name: 'provider', dynamic: true, namespaced: true, store })
class ProviderInfo extends VuexModule implements ProviderState {
  provider: ProviderModel = <ProviderModel>{};
  user: UserModel = <UserModel>{ role: {} };
  engineer: EngineerModel = <EngineerModel>{ role: {} };
  serviceDeskIds: Array<number> = []
  passwordValidity: pwdModel = <pwdModel>{};
  permissions: Array<string> = [];
  mainPic = require('@/assets/icon/logo_helpdesk.png');
  eweiHelpcenterApiUrl = '';

  get providerId () {
    return this.provider.id
  }

  get providerName () {
    return this.provider.name
  }
  
  @Mutation
  private SET_HELPCENTER_API_URL (url: string) {
    this.eweiHelpcenterApiUrl = url
  }

  @Mutation
  private SET_PROVIDER_INFO (info: ProviderModel) {
    this.provider = info;
  }

  @Mutation
  private SET_USER_INFO (info: UserModel) {
    this.user = info;
  }

  @Mutation
  private SET_ENGINEER_INFO (info: EngineerModel) {
    this.engineer = info;
  }

  @Mutation
  private SET_SERVICEDESK_IDS (ids: Array<number>) {
    this.serviceDeskIds = ids;
  }

  @Mutation
  private SET_PERMISSIONS (list: Array<string>) {
    this.permissions = list;
  }

  @Mutation
  private SET_MAIN_PIC (url: string) {
    this.mainPic = url
  }

  @Action({ rawError: true })
  public getProviderInfo () {
    return OpenConsoleApi.consoleConfigData().then(async (data: any) => {
      const id = data.provider.id
      Config._provder_id = id
      this.SET_HELPCENTER_API_URL(data.eweiHelpcenterApiUrl || location.protocol + '//help.' + data.domainRoot + '/')
      this.SET_PROVIDER_INFO(data.provider)
      this.SET_USER_INFO(data.user)
      this.SET_ENGINEER_INFO(data.engineer)
      this.SET_SERVICEDESK_IDS(data.serviceDeskIds)
      OemModule.init();
      await this.getPermissions(data.engineer?.roleId)
      return data
    })
  }

  @Action({ rawError: true })
  public getPermissions (roleId?: number) {
    if (!roleId) {
      this.SET_PERMISSIONS([])
      return Promise.resolve([])
    }
    return OpenConsoleApi.getPermissions(roleId).then(list => {
      this.SET_PERMISSIONS(list)
      return list
    }).catch(() => ([]))
  }

  @Action
  public setProviderMainPic (url: string) {
    if (!url) return
    this.SET_MAIN_PIC(url)
  }
}

export const ProviderModule = getModule(ProviderInfo)
